
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tour/[slug]/[stop]",
      function () {
        return require("private-next-pages/tour/[slug]/[stop].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tour/[slug]/[stop]"])
      });
    }
  